import React from "react";
import TMSIframe from "../iframe-component/TMSIframe";

const Dashboard = () => {
  return <TMSIframe path="/dashboard" />;
};

export default React.memo(Dashboard);
